import { defineComponent } from 'vue'
import { Popup } from 'vant'

export default defineComponent({
  name: 'VanPopup',
  setup(_, { attrs, slots }) {
    return () => <Popup {...attrs} v-slots={slots} />
  },
})
